module.exports = __webpack_public_path__ + "img/multiplier_normal_5.76d1e111.png";